import { render } from "./siteMetaConfig.vue?vue&type=template&id=c535bb62"
import script from "./siteMetaConfig.vue?vue&type=script&lang=js"
export * from "./siteMetaConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__